// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.

import { errorMessage } from "../lib/format";
import { t } from "../lib/messages";

/**
 * A fixed-height placeholder that reserves the space its content will take, so nothing
 * moves when the data arrives (CLS < 0.1, BFS 4.1.4 / SH8-T02).
 */
export function Skeleton({ blockSize = "240px" }: { blockSize?: `${number}px` }) {
  return (
    <s-section>
      <s-stack minBlockSize={blockSize} alignItems="center" justifyContent="center">
        <s-spinner accessibilityLabel={t("loading.page")} />
      </s-stack>
    </s-section>
  );
}

/** The same fixed-height placeholder for a part of a section (no section of its own). */
export function LoadingBlock({ blockSize = "160px" }: { blockSize?: `${number}px` }) {
  return (
    <s-stack minBlockSize={blockSize} alignItems="center" justifyContent="center">
      <s-spinner accessibilityLabel={t("loading.page")} />
    </s-stack>
  );
}

/**
 * An error shown inline where the failed content would be. It stays until the merchant
 * retries (BFS: errors are inline and persistent). Critical tone is used for errors only.
 */
export function ErrorBanner({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  return (
    <s-banner tone="critical" heading={t("error.heading")}>
      <s-paragraph>{errorMessage(error)}</s-paragraph>
      {onRetry && (
        <s-button slot="secondary-actions" onClick={onRetry}>
          {t("error.retry")}
        </s-button>
      )}
    </s-banner>
  );
}
